<template>
  <b-modal
    id="saveAudioModal"
    modal-class="modal-doom-yoga save-media-modal"
    centered
    lazy
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
  >
    <template #modal-title v-if="type == 'music_library'">
      Music Info
    </template>
    <!-- <template #modal-title v-else> Meditation Info </template> -->
    <template #modal-title v-else>
      <span v-if="action_type == 'add'">Add New Audio</span>
      <span v-if="action_type == 'edit'">Audio Info</span></template
    >

    <b-form @submit.prevent="onSubmit">
      <input type="hidden" v-model="type" />
      <b-row class="mt-3">
        <b-col lg="4" md="5">
          <b-row>
            <b-col md="12">
              <p class="error_validation_message_p_dy" v-if="invalid_audio">
                Please add audio
              </p>
              <div
                class="audio-preview-container audio-preview-container-doomyoga"
              >
                <VueFileAgent
                  class="audio-preview-container mt-2"
                  ref="vueFileAgent"
                  :accept="'audio/*'"
                  :multiple="false"
                  :linkable="true"
                  :deletable="true"
                  :meta="true"
                  :resumable="true"
                  @select="filesSelected($event)"
                  @beforedelete="onBeforeDelete($event)"
                  @delete="fileDeleted($event)"
                  v-model="selectedfile"
                >
                  <template v-slot:file-preview-new>
                    <div key="new">
                      <p>Drag and drop file</p>
                      <b-button
                        type="button"
                        variant="doomyoga-danger-outline"
                        class="btn-doom-yoga-submit w-100"
                      >
                        Add Audio
                      </b-button>
                    </div>
                  </template>
                </VueFileAgent>
              </div>
              <b-progress
                v-if="is_loading"
                class="progress-bar-doom-yoga my-1"
                max="100"
                height="1rem"
                show-progress
              >
                <b-progress-bar
                  :value="uploadAudioPercentage"
                  :label="uploadAudioPercentage + ' %'"
                ></b-progress-bar>
              </b-progress>
            </b-col>
            <b-col md="12" class="mt-3">
              <p class="error_validation_message_p_dy" v-if="invalid_image">
                Please add cover image
              </p>
              <VueFileAgent
                class="
                  audio-preview-container audio-preview-container-doomyoga
                  mt-2
                "
                ref="vueFileAgentImg"
                :multiple="false"
                :deletable="true"
                :meta="true"
                :accept="'image/*'"
                @select="filesSelectedImage($event)"
                @beforedelete="onBeforeDeleteImage($event)"
                @delete="fileDeletedImage($event)"
                v-model="selectedfileImage"
              >
                <template v-slot:file-preview-new>
                  <div key="new">
                    <p>Drag and drop file</p>
                    <b-button
                      type="button"
                      variant="doomyoga-danger-outline"
                      class="btn-doom-yoga-submit w-100"
                    >
                      Add Cover Image
                    </b-button>
                  </div>
                </template> </VueFileAgent
              ><b-progress
                v-if="is_loading"
                class="progress-bar-doom-yoga my-1"
                max="100"
                height="1rem"
                show-progress
              >
                <b-progress-bar
                  :value="uploadImagePercentage"
                  :label="uploadImagePercentage + ' %'"
                ></b-progress-bar>
              </b-progress>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="8" md="7">
          <b-row>
            <b-col md="12">
              <b-form-group
                label="Tiltle"
                label-for="audio_title"
                :audio_title="audio_title"
                label-class="form-label-doomyoga"
              >
                <b-form-input
                  id="audio_title"
                  class="form-control-doomyoga"
                  v-model="audio_title"
                  :audio_title="audio_title"
                  required
                ></b-form-input>
              </b-form-group> </b-col
            ><b-col md="12">
              <b-form-group
                label="Audio file description (optional)"
                label-for="audio_description"
                :audio_description="audio_description"
                label-class="form-label-doomyoga"
              >
                <b-form-textarea
                  id="audio_description"
                  class="form-control-doomyoga"
                  v-model="audio_description"
                  :audio_description="audio_description"
                  rows="3"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                label="Created by"
                label-for="created_by"
                :created_by="created_by"
                label-class="form-label-doomyoga"
              >
                <b-form-input
                  id="created_by"
                  class="form-control-doomyoga"
                  v-model="created_by"
                  :created_by="created_by"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                class="form-group-vselect-doomyoga"
                :label="type == 'music_library' ? 'Playlist' : 'Category'"
                label-for="playlist"
                :playlist="playlist"
                label-class="form-label-doomyoga"
              >
                <p
                  class="error_validation_message_p_dy"
                  v-if="invalid_playlist && type == 'music_library'"
                >
                  Please select playlist
                </p>
                <p
                  class="error_validation_message_p_dy"
                  v-if="invalid_playlist && type == 'meditation_library'"
                >
                  Please select category
                </p>
                <v-select
                  :options="playlist_list"
                  multiple
                                                    :closeOnSelect="true"
                  name="playlist"
                  title="playlist"
                  v-model="playlist"
                  :value="playlist"
                  :placeholder="
                    type == 'music_library'
                      ? 'Select playlist'
                      : 'Select category'
                  "
                  required
                  label="title"
                  :reduce="(item) => item.id"
                  @input="setSelectedPlaylist"
                ></v-select
              ></b-form-group> </b-col
            ><b-col
              md="12"
              v-if="
                playlist != null &&
                (playlist === 'new' || playlist.code == 'new')
              "
            >
              <b-form-group
                :label="
                  type == 'music_library'
                    ? 'Playlist category title'
                    : 'Category title'
                "
                label-for="playlist_title"
                :playlist_title="playlist_title"
                label-class="form-label-doomyoga"
              >
                <b-form-input
                  id="playlist_title"
                  class="form-control-doomyoga"
                  v-model="playlist_title"
                  :playlist_title="playlist_title"
                  required
                ></b-form-input>
              </b-form-group> </b-col
            ><b-col
              md="12"
              v-if="
                playlist != null &&
                (playlist === 'new' || playlist.code == 'new')
              "
            >
              <b-form-group
                :label="
                  type == 'music_library'
                    ? 'Playlist Description (optional)'
                    : 'Category Description (optional)'
                "
                label-for="playlist_description"
                :playlist_description="playlist_description"
                label-class="form-label-doomyoga"
              >
                <b-form-textarea
                  id="playlist_description"
                  class="form-control-doomyoga"
                  v-model="playlist_description"
                  :playlist_description="playlist_description"
                  rows="3"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                label="Time duration"
                label-for="time_duration"
                :time_duration="time_duration"
                class=""
                label-class="form-label-doomyoga"
              >
                <!-- <b-form-input
                  id="time_duration"
                  class="form-control-doomyoga"
                  type="number"
                  min="1"
                  v-model="time_duration"
                  :time_duration="time_duration"
                  required
                ></b-form-input> -->
                <span class="form-control form-control-doomyoga">{{
                  time_duration
                }}</span>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col> </b-row
      ><b-row class="mt-4">
        <b-col>
          <b-button
            variant="doomyoga-primary"
            class="btn-bumblebee btn-doomyoga btn-doom-yoga-submit float-right"
            type="submit"
            v-if="!is_loading && type == 'music_library'"
          >
            <span v-if="action_type == 'add'">Add Music</span>
            <span v-if="action_type == 'edit'">Save music</span>
          </b-button>
          <b-button
            variant="doomyoga-primary"
            class="btn-bumblebee btn-doomyoga btn-doom-yoga-submit float-right"
            type="submit"
            v-if="!is_loading && type == 'meditation_library'"
          >
            <span v-if="action_type == 'add'">Add Meditation</span>
            <span v-if="action_type == 'edit'">Save Meditation</span>
          </b-button>
          <b-button
            type="button"
            disabled
            variant="doomyoga-primary"
            class="btn-bumblebee btn-doomyoga btn-doom-yoga-submit float-right"
            v-if="is_loading"
          >
            <b-spinner small label="Small Spinner" variant="light"></b-spinner>
            Loading
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import $ from "jquery";
import axios from "axios";

import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
// import '@/assets/js/file-input-preview/piexif.min.js'
// import '@/assets/js/file-input-preview/sortable.min.js'
// import '@/assets/js/file-input-preview/popper.min.js'
// import '@/assets/js/bootstrap.bundle.min.js'
// import '@/assets/js/file-input-preview/fileinput.min.js'
// import '@/assets/js/file-input-preview/theme.js'
import { convertSecToHMSText, formatBytes } from "@/utils/helper-functions.js";

export default {
  name: "AddMusicMp3",
  props: [
    "type",
    "sub_type",
    "action_type",
    "playlist",
    "playlist_list",
    "category",
    "id",
    "audio_title",
    "audio_description",
    "created_by",
    "time_duration",
    "audio_id",
    "image_id",
    "media_obj",
    "cover_obj",
  ],

  data() {
    return {
      client_name: "DY",

      audio_title: "",
      audio_description: "",
      created_by: "",
      time_duration: null,
      is_loading: false,
      audio: null,
      invalid_audio: null,
      selectedfile: [],
      selectedfileForUpload: [], // maintain an upload queue
      invalid_image: false,
      selectedfileImage: [],
      selectedfileForUploadImage: [], // maintain an upload queue
      // playlist_list: [
      //   { label: "Playlist 1", code: "1" },
      //   { label: "Playlist 2", code: "2" },
      //   { label: "New playlist", code: "new" },
      // ],
      playlist_title: null,
      playlist_description: null,
      invalid_playlist: false,
      uploadAudioPercentage: 0,
      uploadImagePercentage: 0,
      // audio_id: null,
      // image_id: null,
    };
  },
  mounted() {
    console.log("selected cat/playlist", this.playlist);
  },
  watch: {
    playlist(newval, oldval) {
      console.log(newval, oldval);
    },
    media_obj(newval, oldval) {
      console.log(this.selectedfile);
      console.log(newval);
      console.log(oldval);
      this.selectedfile = newval;
      console.log(this.selectedfile);
      // this.selectedfileForUpload = newval;
    },
    cover_obj(newval, oldval) {
      console.log(this.selectedfileImage);
      console.log(newval);
      console.log(oldval);
      this.selectedfileImage = newval;
      console.log(this.selectedfileImage);
      // this.selectedfileForUpload = newval;
    },
  },
  methods: {
    convertSecToHMSText,
    formatBytes,
    setSelectedPlaylist(value) {
      console.log(value);
      console.log(value.indexOf("new"));
      if (value.indexOf("new") != -1) {
        this.playlist = this.playlist_list[this.playlist_list.length - 1].id;
      }
      console.log(this.playlist);
    },
    filesSelected(fileRecords) {
      console.log("filesSelected", fileRecords);
      console.log(fileRecords[0].file);

      var validFileRecords = [];
      for (var i = 0; i < fileRecords.length; i++) {
        if (!this.selectedfile[i].error) {
          validFileRecords.push(this.selectedfile[i]);
        }
      }
      console.log("filesSelected", this.selectedfile, validFileRecords);
      this.selectedfileForUpload =
        this.selectedfileForUpload.concat(validFileRecords);

      let temp = this;
      var audio = document.createElement("audio");
      audio.preload = "metadata";
      audio.onloadedmetadata = function () {
        window.URL.revokeObjectURL(audio.src);
        var duration = audio.duration;
        console.log(duration);
        console.log(duration / 60);
        console.log(duration / 60 / 60);
        console.log(temp.convertSecToHMSText(duration));
        temp.time_duration = temp.convertSecToHMSText(duration);
      };
      audio.src = URL.createObjectURL(validFileRecords[0].file);

      console.log(this.selectedfile);
      console.log(this.selectedfileForUpload);
      this.audio_id = null;
    },
    filesSelectedImage(fileRecords) {
      console.log("filesSelected", fileRecords);
      var validFileRecords = [];
      for (var i = 0; i < fileRecords.length; i++) {
        if (!this.selectedfileImage[i].error) {
          validFileRecords.push(this.selectedfileImage[i]);
        }
      }
      console.log("filesSelected", this.selectedfileImage, validFileRecords);
      this.selectedfileForUploadImage =
        this.selectedfileForUploadImage.concat(validFileRecords);

      console.log(this.selectedfileImage);
      console.log(this.selectedfileForUploadImage);
      this.image_id = null;
    },
    onBeforeDelete(fileRecord) {
      console.log("in before delete");
      console.log(fileRecord);
      // var i = this.selectedfileForUpload.indexOf(fileRecord);
      // if (i !== -1) {
      //   this.selectedfileForUpload.splice(i, 1);
      //   var k = this.selectedfile.indexOf(fileRecord);
      //   if (k !== -1) this.selectedfile.splice(k, 1);
      // } else {
      //   // if (confirm("Are you sure you want to delete?")) {
      //   // this.$refs.vueFileAgent.deleteFileRecord(fileRecord); // will trigger 'delete' event
      //   // }
      // }
      this.selectedfile = [];
      this.selectedfileForUpload = [];
      this.audio_id = null;
    },
    onBeforeDeleteImage(fileRecord) {
      console.log(fileRecord);
      // var i = this.selectedfileForUploadImage.indexOf(fileRecord);
      // if (i !== -1) {
      //   this.selectedfileForUploadImage.splice(i, 1);
      // } else {
      //   // if (confirm("Are you sure you want to delete?")) {
      //   // this.$refs.vueFileAgent.deleteFileRecord(fileRecord); // will trigger 'delete' event
      //   // }
      // }

      this.selectedfileImage = [];
      this.selectedfileForUploadImage = [];
      this.image_id = null;
    },
    fileDeleted(fileRecord) {
      console.log(fileRecord);
      var i = this.selectedfileForUpload.indexOf(fileRecord);
      if (i !== -1) {
        this.selectedfileForUpload.splice(i, 1);
      } else {
        // this.deleteUploadedFile(fileRecord);
      }
      console.log(this.selectedfile);
      console.log(this.selectedfileForUpload);
    },
    fileDeletedImage(fileRecord) {
      console.log(fileRecord);
      var i = this.selectedfileForUploadImage.indexOf(fileRecord);
      if (i !== -1) {
        this.selectedfileForUploadImage.splice(i, 1);
      } else {
        // this.deleteUploadedFile(fileRecord);
      }
      console.log(this.selectedfileImage);
      console.log(this.selectedfileForUploadImage);
    },

    onSubmit(event) {
      console.log(event);
      console.log(this.audio_title);
      console.log(this.audio_description);
      console.log(this.created_by);
      console.log(this.type);
      console.log(this.playlist);
      console.log(this.playlist_title, this.playlist_description);
      console.log(this.selectedfile);
      console.log(this.selectedfileImage);
      console.log(this.audio_id, this.image_id);

      this.is_loading = true;

      if (
        this.playlist == null ||
        this.playlist == "" ||
        this.playlist.length == 0
      ) {
        this.invalid_playlist = true;
      } else {
        this.invalid_playlist = false;
      }

      if (this.selectedfile == null || this.selectedfile.length == 0) {
        this.invalid_audio = true;
      } else {
        this.invalid_audio = false;
      }
      if (
        this.selectedfileImage == null ||
        this.selectedfileImage.length == 0
      ) {
        this.invalid_image = true;
      } else {
        this.invalid_image = false;
      }

      if (
        !this.invalid_audio &&
        !this.invalid_image &&
        !this.invalid_category
      ) {
        if (this.action_type == "add") {
          this.uploadMediaRequest("audio");
        } else if (this.action_type == "edit") {
          if (this.audio_id == null) {
            this.uploadMediaRequest("audio");
          } else {
            if (this.image_id == null) {
              this.uploadMediaRequest("image");
            } else {
              if (this.playlist == "new") {
                // alert("new");
                this.sendSaveCategoryRequest();
              } else {
                this.sendEditAudioRequest();
              }
            }
          
          }
        }
      } else {
        this.is_loading = false;
      }
    },
    uploadMediaRequest(type) {
      console.log("upload media request", type);
      console.log(this.selectedfile[0].file);
      console.log(this.selectedfileImage[0].file);
      let formData = new FormData();
      formData.append("client", this.client_name);
      if (type == "audio") {
        formData.append("selectedfile", this.selectedfile[0].file);
      } else if (type == "image") {
        formData.append("selectedfile", this.selectedfileImage[0].file);
      }

      axios
        .post("filesmodule/upload", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
          onUploadProgress: function (progressEvent) {
            console.log("--------", progressEvent.loaded, progressEvent.total);
            if (type == "audio") {
              this.uploadAudioPercentage = parseInt(
                Math.round((progressEvent.loaded / progressEvent.total) * 100)
              );
            } else {
              this.uploadImagePercentage = parseInt(
                Math.round((progressEvent.loaded / progressEvent.total) * 100)
              );
            }
          }.bind(this),
        })
        .then((response) => {
          console.log(response);
          //this.is_loading = false;
          // this.cover_image_id = response.data.id;
          // this.getEventDataToSend();
          if (type == "audio") {
            this.audio_id = response.data.id;
            if (this.action_type == "add") {
              this.uploadMediaRequest("image");
            } else if (this.action_type == "edit") {
              if (this.image_id == null) {
                this.uploadMediaRequest("image");
              } else {
                if (this.playlist == "new") {
                  // alert("new");
                  this.sendSaveCategoryRequest();
                } else {
                  this.sendEditAudioRequest();
                }
              }
            }
          } else if (type == "image") {
            this.image_id = response.data.id;
            console.log("cont send audio data", this.category);
            if (this.action_type == "add") {
              if (this.playlist == "new") {
                // alert("new");
                this.sendSaveCategoryRequest();
              } else {
                this.sendAddAudioRequest();
              }
            } else if (this.action_type == "edit") {
              if (this.playlist == "new") {
                // alert("new");
                this.sendSaveCategoryRequest();
              } else {
                this.sendEditAudioRequest();
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
          this.$fire({
            // title: "Title",
            text: error,
            type: "error",
            // timer: 5000,
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
          }).then((r) => {
            // console.log(r.value);
            this.is_loading = false;
          });
        });
    },
    sendAddAudioRequest() {
      console.log("in send save audio request");
      console.log(this.audio_title, this.audio_description);
      console.log(this.type);
      console.log(this.created_by, this.time_duration);
      console.log(this.audio_id, this.image_id);
      console.log(this.playlist);
      console.log(this.playlist_title, this.playlist_description);

      // return;
      console.log("----------------");
      console.log(this.selectedfile);
      console.log(this.selectedfile[0]);
      console.log(this.selectedfileImage);
      console.log(this.selectedfileImage[0]);
      let formData = new FormData();
      formData.append("title", this.audio_title);
      formData.append("description", this.audio_description);
      formData.append("media_library", this.type);
      formData.append("sub_library_name", "audio");
      formData.append("created_by", this.created_by);
      formData.append("time_duration", this.time_duration);
      formData.append("media_id", this.audio_id);
      formData.append("cover_image_id", this.image_id);
      this.playlist.forEach((item) => {
        formData.append("categories[]", item);
      });

      this.is_loading = true;

      axios
        .post("media/library/add-media", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          console.log(response.data.image_file);

          this.$fire({
            // title: "Title",
            text: "Audio is saved successfully",
            type: "success",
            timer: 3000,
          }).then((r) => {
            this.$bvModal.hide("addAudioModal");
            this.is_loading = false;
            // this.$parent.$parent.getaudiosCategoryList();
            this.$router.go();
          });
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: "Sorry, error in saving audio",
            type: "error",
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
            this.is_loading = false;
          });
        });
    },
    sendEditAudioRequest() {
      console.log("in send save audio request");
      console.log(this.audio_title, this.audio_description);
      console.log(this.type);
      console.log(this.created_by, this.time_duration);
      console.log(this.audio_id, this.image_id);
      console.log(this.playlist);
      console.log(this.playlist_title, this.playlist_description);

      // return;
      console.log("----------------");
      console.log(this.selectedfile);
      console.log(this.selectedfile[0]);
      console.log(this.selectedfileImage);
      console.log(this.selectedfileImage[0]);
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("title", this.audio_title);
      formData.append("description", this.audio_description);
      formData.append("media_library", this.type);
      formData.append("sub_library_name", "audio");
      formData.append("created_by", this.created_by);
      formData.append("time_duration", this.time_duration);
      formData.append("media_id", this.audio_id);
      formData.append("cover_image_id", this.image_id);
      this.playlist.forEach((item) => {
        formData.append("categories[]", item);
      });

      this.is_loading = true;

      axios
        .post("media/library/edit-media", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          console.log(response.data.image_file);

          this.$fire({
            // title: "Title",
            text: "Audio is updated successfully",
            type: "success",
            timer: 3000,
          }).then((r) => {
            this.$bvModal.hide("addAudioModal");
            this.is_loading = false;
            // this.$parent.$parent.getaudiosCategoryList();
            this.$router.go();
          });
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: "Sorry, error in saving audio",
            type: "error",
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
            this.is_loading = false;
          });
        });
    },
    sendSaveCategoryRequest() {
      console.log("in send add cateogry request");
      console.log(this.playlist_title, this.playlist_description);
      console.log(this.type);
      let formData = new FormData();
      formData.append("client", this.client_name);
      formData.append("title", this.playlist_title);
      formData.append("description", this.playlist_description);
      formData.append("sub_library", "audio");
      formData.append("media_library", this.type);

      axios
        .post("category/create", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);

          this.playlist = [response.data.category.id];
          if (this.action_type == "add") {
            this.sendSaveAudioRequest();
          } else if (this.action_type == "edit") {
            this.sendEditAudioRequest();
          }

          // this.$fire({
          //   // title: "Title",
          //   text: "Category is saved successfully",
          //   type: "success",
          //   timer: 3000,
          // }).then((r) => {
          //   this.is_loading = false;
          //   //reset form
          //   this.category_title = "";
          //   this.category_description = "";
          //   this.$bvModal.hide("saveCategoryModal");
          //   console.log(this.$parent.$parent);
          //   this.$parent.$parent.getaudiosCategoryList();
          // });
          // this.$router.go();
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: "Sorry, error in saving category",
            type: "error",
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
            this.is_loading = false;
          });
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/doom_yoga/media/SaveAudio.vue